import { render, staticRenderFns } from "./LotteryWinDialog.vue?vue&type=template&id=1aaa4b46&scoped=true"
import script from "./LotteryWinDialog.vue?vue&type=script&lang=js"
export * from "./LotteryWinDialog.vue?vue&type=script&lang=js"
import style0 from "./LotteryWinDialog.vue?vue&type=style&index=0&id=1aaa4b46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaa4b46",
  null
  
)

export default component.exports